// Auth
export const AUTH_USER = 'AUTH_USER';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_ERROR = 'AUTH_USER_ERROR';
export const AUTH_USER_INITIATE_LOGOUT = 'AUTH_USER_INITIATE_LOGOUT';
export const AUTH_USER_LOGOUT = 'AUTH_USER_LOGOUT';
export const AUTH_USER_AUTO_LOGOUT = 'AUTH_USER_AUTO_LOGOUT';
export const AUTH_USER_CHECK_STATE = 'AUTH_USER_CHECK_STATE';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTH_LOADING_INDICATOR = 'SET_AUTH_LOADING_INDICATOR';

// Registration & Password
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_ERROR = 'RESET_USER_PASSWORD_ERROR';
export const ACTIVATE_USER = 'ACTIVATE_USER';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';

// Users
export const SET_USERS = 'SET_USERS';
export const SET_USER = 'SET_USER';

// Teachers
export const ADD_TEACHER_START = 'ADD_TEACHER_START';
export const ADD_TEACHER_SUCCESS = 'ADD_TEACHER_SUCCESS';
export const HANDLE_TEACHER_START = 'HANDLE_TEACHER_START';
export const UPDATE_TEACHER_START = 'UPDATE_TEACHER_START';
export const UPDATE_TEACHER_SUCCESS = 'UPDATE_TEACHER_SUCCESS';
export const DELETE_TEACHER_START = 'DELETE_TEACHER_START';
export const DELETE_TEACHER_SUCCESS = 'DELETE_TEACHER_SUCCESS';
export const SHOW_ALL_TEACHERS_START = 'SHOW_ALL_TEACHERS_START';
export const SHOW_ALL_TEACHERS_SUCCESS = 'SHOW_ALL_TEACHERS_SUCCESS';
export const SET_DISABLED_TEACHERS_START = 'SET_DISABLED_TEACHERS_START';
export const SET_DISABLED_TEACHERS_SUCCESS = 'SET_DISABLED_TEACHERS_SUCCESS';
export const GET_TEACHERS_WITH_EMAIL_START = 'GET_TEACHERS_WITH_EMAIL_START';
export const GET_TEACHERS_WITH_EMAIL_SUCCESS = 'GET_TEACHERS_WITH_EMAIL_SUCCESS';
export const GET_TEACHERS_BY_DEPARTMENT = 'GET_TEACHERS_BY_DEPARTMENT';
export const GET_ALL_PUBLIC_TEACHERS_START = 'GET_ALL_PUBLIC_TEACHERS_START';
export const GET_ALL_PUBLIC_TEACHERS_BY_DEPARTMENT_START = 'GET_ALL_PUBLIC_TEACHERS_BY_DEPARTMENT_START';
export const TOOGLE_TEACHER_START = 'TOOGLE_TEACHER_START';
export const SELECT_TEACHER = 'SELECT_TEACHER';
export const SET_TEACHER = 'SET_TEACHER';
export const SELECT_TEACHER_ID = 'SELECT_TEACHER_ID';
export const SET_TEACHER_VIEW_TYPE = 'SET_TEACHER_VIEW_TYPE';

// Groups
export const SHOW_ALL_GROUPS_SUCCESS = 'SHOW_ALL_GROUPS_SUCCESS';
export const SELECT_GROUP_SUCCESS = 'SELECT_GROUP_SUCCESS';
export const SELECT_GROUP_ID = 'SELECT_GROUP_ID';
export const GET_GROUPS_FOR_CURRENT_SEMESTER_START = 'GET_GROUPS_FOR_CURRENT_SEMESTER_START';

// Students
export const SHOW_ALL_STUDENTS = 'SHOW_ALL_STUDENTS';
export const CREATE_STUDENT = 'CREATE_STUDENT';
export const CREATE_STUDENT_START = 'CREATE_STUDENT_START';
export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const UPDATE_STUDENT_START = 'UPDATE_STUDENT_START';
export const DELETE_STUDENT = 'DELETE_STUDENT';
export const DELETE_STUDENT_START = 'DELETE_STUDENT_START';
export const DELETE_SELECTED_STUDENTS = 'DELETE_SELECTED_STUDENTS';
export const SET_STUDENT = 'SET_STUDENT';
export const GET_ALL_STUDENTS = 'GET_ALL_STUDENTS';
export const CHECK_ALL_STUDENTS = 'CHECK_ALL_STUDENTS';
export const MOVE_STUDENTS_TO_GROUP_START = 'MOVE_STUDENTS_TO_GROUP_START';
export const UPLOAD_FILE_STUDENT_START = 'UPLOAD_FILE_STUDENT_START';
export const SUBMIT_STUDENT_FORM = 'SUBMIT_STUDENT_FORM';
export const SET_STUDENTS_LOADING_INDICATOR = 'SET_STUDENTS_LOADING_INDICATOR';

// Rooms
export const SHOW_LIST_OF_ROOMS_SUCCESS = 'SHOW_LIST_OF_ROOMS_SUCCESS';
export const GET_LIST_OF_ROOMS_START = 'GET_LIST_OF_ROOMS_START';
export const SET_SELECT_ROOM = 'SET_SELECT_ROOM';

// Subjects
export const SHOW_ALL_SUBJECTS = 'SHOW_ALL_SUBJECT';
export const SELECT_SUBJECT = 'SELECT_SUBJECT';

// Departments
export const GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS';

// Semesters
export const ADD_SEMESTER_START = 'ADD_SEMESTER_START';
export const ADD_SEMESTER_SUCCESS = 'ADD_SEMESTER_SUCCESS';
export const UPDATE_SEMESTER_START = 'UPDATE_SEMESTER_START';
export const UPDATE_SEMESTER_SUCCESS = 'UPDATE_SEMESTER_SUCCESS';
export const UPDATE_SEMESTER_BY_ID_START_SUCCESS = 'UPDATE_SEMESTER_BY_ID_START_SUCCESS';
export const DELETE_SEMESTER_START = 'DELETE_SEMESTER_START';
export const DELETE_SEMESTER_SUCCESS = 'DELETE_SEMESTER_SUCCESS';
export const SHOW_ALL_SEMESTERS_SUCCESS = 'SHOW_ALL_SEMESTER';
export const GET_ALL_SEMESTERS_START = 'GET_ALL_SEMESTER_START';
export const SELECT_SEMESTER_SUCCESS = 'SELECT_SEMESTER_SUCCESS';
export const HANDLE_SEMESTER_FORM_SUBMIT_START = 'HANDLE_SEMESTER_FORM_SUBMIT_START';
export const SET_SEMESTER_COPY_START = 'SEMESTER_COPY_START';
export const CLEAR_SEMESTER_SUCCESS = 'CLEAR_SEMESTER_SUCCESS';
export const SET_DISABLED_SEMESTERS_SUCCESS = 'SET_DISABLED_SEMESTERS_SUCCESS';
export const GET_DISABLED_SEMESTERS_START = 'GET_DISABLED_SEMESTERS_START';
export const SET_ARCHIVED_SEMESTERS_START = 'SET_ARCHIVED_SEMESTERS_START';
export const SET_ARCHIVED_SEMESTERS_SUCCESS = 'SET_ARCHIVED_SEMESTERS_SUCCESS';
export const GET_ARCHIVE_SEMESTER_BY_ID_START = 'GET_ARCHIVE_SEMESTER_BY_ID_START';
export const CREATE_ARCHIVE_SEMESTER_START = 'CREATE_ARCHIVE_SEMESTER_START';
export const SET_GROUPS_TO_SEMESTER_START = 'SET_GROUPS_TO_SEMESTER_START';
export const TOGGLE_SEMESTER_VISIBILITY_START = 'TOGGLE_SEMESTER_VISIBILITY_START';
export const MOVE_SEMESTER_TO_ARCHIVE_SUCCESS = 'MOVE_SEMESTER_TO_ARCHIVE_SUCCESS';
export const SET_SEMESTER_LOADING_INDICATOR = 'SET_SEMESTER_LOADING_INDICATOR';

// Lessons
export const GET_LESSONS_CARDS_START = 'GET_LESSONS_CARDS_START';
export const SET_LESSONS_CARDS_START = 'SET_LESSONS_CARDS_START';
export const GET_LESSONS_BY_TEACHER_START = 'GET_LESSONS_BY_TEACHER_START';
export const GET_LESSONS_BY_TEACHER_SUCCESS = 'GET_LESSONS_BY_TEACHER_SUCCESS';
export const UPDATE_LESSON_LINK_START = 'UPDATE_LESSON_LINK_START';
export const UPDATE_LESSON_LINK_SUCCESS = 'UPDATE_LESSON_LINK_SUCCESS';
export const UPDATE_LESSONS_LINK_START = 'UPDATE_LESSONS_LINK_START';
export const UPDATE_LESSONS_LINK_SUCCESS = 'UPDATE_LESSONS_LINK_SUCCESS';
export const CLEAR_TEACHER_LESSONS = 'CLEAR_TEACHER_LESSONS';
export const SET_TEACHER_LESSONS_LOADING = 'SET_TEACHER_LESSONS_LOADING';
export const GET_MY_LESSONS_START = 'GET_MY_LESSONS_START';

// Classes
export const GET_CLASS_SCHEDULE_LIST_START = 'GET_CLASS_SCHEDULE_LIST_START';
export const GET_CLASS_SCHEDULE_LIST_SUCCESS = 'GET_CLASS_SCHEDULE_LIST_SUCCESS';
export const GET_PUBLIC_CLASS_SCHEDULE_LIST_START = 'GET_PUBLIC_CLASS_SCHEDULE_LIST_START';
export const GET_PUBLIC_CLASS_SCHEDULE_LIST_SUCCESS = 'GET_PUBLIC_CLASS_SCHEDULE_LIST_SUCCESS';

// Schedules
export const GET_SCHEDULE_ITEMS_START = 'GET_SCHEDULE_ITEMS_START';
export const GET_SCHEDULE_ITEMS_SUCCESS = 'GET_SCHEDULE_ITEMS_SUCCESS';
export const GET_FULL_SCHEDULE_START = 'GET_FULL_SCHEDULE_START';
export const GET_FULL_SCHEDULE_SUCCESS = 'GET_FULL_SCHEDULE_SUCCESS';
export const GET_GROUP_SCHEDULE_START = 'GET_GROUP_SCHEDULE_START';
export const GET_GROUP_SCHEDULE_SUCCESS = 'GET_GROUP_SCHEDULE_SUCCESS';
export const GET_TEACHER_SCHEDULE_START = 'GET_TEACHER_SCHEDULE_START';
export const GET_TEACHER_SCHEDULE_SUCCESS = 'GET_TEACHER_SCHEDULE_SUCCESS';
export const GET_TEACHER_ACTIVE_SEMESTERS_SCHEDULE_START = 'GET_TEACHER_ACTIVE_SEMESTERS_SCHEDULE_START';
export const GET_TEACHER_RANGE_SCHEDULE_START = 'GET_TEACHER_RANGE_SCHEDULE_START';
export const GET_TEACHER_RANGE_SCHEDULE_SUCCESS = 'GET_TEACHER_RANGE_SCHEDULE_SUCCESS';
export const GET_ALL_SCHEDULE_ITEMS_START = 'GET_ALL_SCHEDULE_ITEMS_START';
export const GET_ALL_PUBLIC_SEMESTERS_START = 'GET_ALL_PUBLIC_SEMESTERS_START';
export const GET_ALL_PUBLIC_SEMESTERS_SUCCESS = 'GET_ALL_PUBLIC_SEMESTERS_SUCCESS';
export const GET_ALL_PUBLIC_GROUPS_START = 'GET_ALL_PUBLIC_GROUPS_START';
export const GET_CURRENT_SEMESTER_START = 'GET_CURRENT_SEMESTER_START';
export const GET_CURRENT_SEMESTER_SUCCESS = 'GET_CURRENT_SEMESTER_SUCCESS';
export const ADD_ITEM_TO_SCHEDULE = 'ADD_ITEM_TO_SCHEDULE';
export const ADD_ITEM_TO_SCHEDULE_START = 'ADD_ITEM_TO_SCHEDULE_START';
export const EDIT_ITEM_TO_SCHEDULE_START = 'EDIT_ITEM_TO_SCHEDULE_START';
export const DELETE_SCHEDULE_ITEM_START = 'DELETE_SCHEDULE_ITEM_START';
export const DELETE_SCHEDULE_ITEM_SUCCESS = 'DELETE_SCHEDULE_ITEM_SUCCESS';
export const UPDATE_SCHEDULE_ITEM_SUCCESS = 'UPDATE_SCHEDULE_ITEM_SUCCESS';
export const CLEAR_SCHEDULE_START = 'CLEAR_SCHEDULE_START';
export const CHECK_AVAILABILITY_SCHEDULE_START = 'CHECK_AVAILABILITY_SCHEDULE_START';
export const CHECK_AVAILABILITY_CHANGE_ROOM_SCHEDULE_START = 'CHECK_AVAILABILITY_CHANGE_ROOM_SCHEDULE_START';
export const CHECK_AVAILABILITY_CHANGE_ROOM_SCHEDULE_SUCCESS = 'CHECK_AVAILABILITY_CHANGE_ROOM_SCHEDULE_SUCCESS';
export const SEND_TEACHER_SCHEDULE_START = 'SEND_TEACHER_SCHEDULE_START';
export const SCHEDULE_NOT_PUBLISHED = 'SCHEDULE_NOT_PUBLISHED';
export const SET_SCHEDULE_OPERATION_LOADING = 'SET_SCHEDULE_OPERATION_LOADING';
export const SET_SCHEDULE_LOADING_INDICATOR = 'SET_SCHEDULE_LOADING_INDICATOR';
export const SET_MAIN_SCHEDULE_LOADING_INDICATOR = 'SET_MAIN_SCHEDULE_LOADING_INDICATOR';
export const SET_SCHEDULE_TYPE = 'SET_SCHEDULE_TYPE';
export const SET_SCHEDULE_GROUP = 'SET_SCHEDULE_GROUP';
export const SET_SCHEDULE_GROUPS = 'SET_SCHEDULE_GROUPS';
export const SET_SCHEDULE_TEACHER = 'SET_SCHEDULE_TEACHER';
export const SET_SCHEDULE_SEMESTER = 'SET_SCHEDULE_SEMESTER';
export const SET_SCHEDULE_DEPARTMENT = 'SET_SCHEDULE_DEPARTMENT';
export const SET_ITEM_GROUP_ID = 'SET_ITEM_GROUP_ID';
export const SET_PLACE = 'SET_PLACE';
export const SELECT_GROUP_SCHEDULE_START = 'SELECT_GROUP_SCHEDULE_START';
export const SELECT_TEACHER_SCHEDULE_START = 'SELECT_TEACHER_SCHEDULE_START';
export const SELECT_FULL_SCHEDULE_START = 'SELECT_FULL_SCHEDULE_START';
export const SELECT_DEPARTMENT_SCHEDULE_START = 'SELECT_DEPARTMENT_SCHEDULE_START';
export const SET_SCHEDULE_PUBLISHED = 'SET_SCHEDULE_PUBLISHED';
export const MOVE_SCHEDULE_ITEM_START = 'MOVE_SCHEDULE_ITEM_START';

// UI
export const SET_LOADING_INDICATOR = 'SET_LOADING_INDICATOR';
export const SET_OPEN_SNACKBAR = 'SET_OPEN_SNACKBAR';
export const SET_ERROR = 'SET_ERROR';
export const SET_IS_OPEN_CONFIRM_DIALOG = 'SET_IS_OPEN_CONFIRM_DIALOG';
